<template>
 <div>
  <img v-if="level > 0"
    src="../assets/angle-arrow.svg"
    class=""
    :style="{
        
        position: 'relative',
        top:this.stageKeysLength > 5  && stage.stage != 'Interview 1'? '8px' : '-2px',
        left:'3px'

    }"

    alt="arrow"
/>
  <div :style="{ marginLeft: level > 0 ?  '2rem': '0rem', paddingLeft: level == 0 ? '0px' :this.stageKeysLength > 5  && stage.stage != 'Interview 1'? '13px':  '10px', marginTop: level == 0 ?  '0.5rem': this.stageKeysLength > 5  && stage.stage != 'Interview 1'? '-0.87rem':  '-1.5rem' }">
    <p class="text-subtitle-2 family-graphik-medium">{{ stage.stage }} </p>
    <v-row >
      <v-col cols="4" :class="[this.stageKeysLength > 5 ? 'pb-1 ': '']">
        <div class="text-caption"><span>Score</span><span class="mx-1">-</span><span>{{ (stage.score?.toFixed(1) || stage.avgScore?.toFixed(1)) || 'NA' }}</span></div>
      </v-col>
      <v-col cols="4" :class="[this.stageKeysLength > 5 ? 'pb-1': '']" v-if="stage?.decesion">
        <div class="text-caption"><span>Decision</span> <span class="mx-1">-</span> <span>{{ stage.decesion }}</span></div>
      </v-col>
      <v-col cols="4" :class="[this.stageKeysLength > 5 ? 'pb-1': '']" v-if="stage?.result">
        <div class="text-caption">Result <span class="mx-1">-</span> <span :class="getPassFailColor(getPassFailGenericVal(stage.result))"> {{ getPassFailGenericVal(stage.result) }}</span></div>
      </v-col>
      <v-col cols="4" :class="[this.stageKeysLength > 5 ? 'pb-1': '']" v-if="stage?.takenBy">
        <div class="text-caption"><span>Taken By</span> <span class="mx-1">-</span><span> {{ stage?.takenBy }}</span></div>
      </v-col>
      <v-col cols="4" :class="[this.stageKeysLength > 5 ? 'pa-0  ml-3': '']" >
        <div  class="text-caption"><span>Date</span> <span class="mx-1">-</span> <span v-if="stage?.date">{{ formatDate(stage?.date)  }}</span> <span v-if="stage?.time">{{  formatDate(stage?.time) }}</span></div>
      </v-col>
      <v-col cols="12" v-if="stage?.remarks" class="py-0">
        <div class="text-caption d-flex">
          <span>Remark</span><span class="mx-1">-</span><span v-html="stage.remarks"></span>
        </div>
      </v-col>
    </v-row>

    <stage-item
      v-if="stage.child"
      :stage="stage.child"
      :level="level + 1"
    />
  </div>
 </div>
</template>

<script>
export default {
  name: 'StageItem',
  props: {
    stage: {
      type: Object,
      required: true
    },
    level: {
      type: Number,
      default: 0
    },
    interviewFirstIndex: {
      type: Number,
      default: 0
      
    }
  },
  computed:{
    stageKeysLength(){
   
      return Object.keys(this.stage).length > 5
    }
  },
  methods:{
    formatDate(date) {
      const d = new Date(date);
      console.log(d)
      if (!date || isNaN(d.getTime())) {
        return 'NA';
      }
      const day = String(d.getDate()).padStart(2, '0');
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const year = d.getFullYear();
      return `${day}/${month}/${year}`;
    },
    getPassFailGenericVal(status){
      if(status !== null && status !== undefined && status !== ''){
        return status.split(' ')[1]?.toLowerCase().trim() == 'passed' ? 'Pass': 'Fail'
      } else{   return ''}
  
    },
    getPassFailColor(status){
    if(status == 'Pass'){
      return 'pass-step'
    }else if (status == 'Fail'){
      return 'fail-color'
    }
   
    }
}
}

</script>

<style scoped>
.v-application .family-graphik-medium {
  font-family: "GraphikMedium", sans-serif !important;
}
strong {
  font-weight: bold;
}
.pass-step{
  color: green
}


</style>
